import { render, staticRenderFns } from "./DetachOrgObjectLine.vue?vue&type=template&id=2439c0dc&scoped=true"
import script from "./DetachOrgObjectLine.vue?vue&type=script&setup=true&lang=js"
export * from "./DetachOrgObjectLine.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DetachOrgObjectLine.vue?vue&type=style&index=0&id=2439c0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2439c0dc",
  null
  
)

export default component.exports